<template>
  <q-layout
    :view="isWideLandscapeView() ? 'hHh lpR fFf' : 'hHh Lpr fFf'"
    class="kiosk-layout"
    style="min-height: 100vh;"
    :style="{ 'background-color': currentSite.backgroundColor }"
  >
    <q-inner-loading :showing="loading" />
    <q-drawer
      v-if="showDrawerLeft && isWideLandscapeView() && checkoutData.showMovieCard && !$_.isNil(order.currentShowing)"
      v-model="showDrawerLeft"
      class="q-pa-md bg-responsive"
      show-if-above
      side="left"
      :width="marginLeft"
      :breakpoint="1024"
      behavior="desktop"
      bordered
    >
      <movie-card
        v-if="!$_.isNil(order.currentShowing?.movie)"
        :showing="order.currentShowing"
        :movie="order.currentShowing.movie"
        :show-all-showtimes-options="$isLandscapeView() && checkoutData.stepTitle === $t('checkout.steps.seats') && !currentSite.consumerConfig.showTicketFirstCheckoutFlow"
        rounded
        flat
        @movie-selected="movie => selectMovie(movie)"
      />
    </q-drawer>

    <q-drawer
      v-else-if="showDrawerLeft && isWideLandscapeView() && checkoutData.showActivityCard && !$_.isNil(order.currentActivity)"
      v-model="showDrawerLeft"
      class="q-pa-md bg-responsive"
      show-if-above
      side="left"
      :width="marginLeft"
      :breakpoint="1024"
      behavior="desktop"
      bordered
    >
      <activity-card
        :activity="order.currentActivity"
        banner-image
        rounded
        flat
      />
    </q-drawer>

    <q-drawer
      v-if="(isWideLandscapeView() || showDrawer) && checkoutData.showCartControls"
      v-model="showDrawer"
      class="bg-transparent"
      :class="isWideLandscapeView() ? undefined : 'portrait'"
      show-if-above
      side="right"
      bordered
      :width="marginRight"
      behavior="desktop"
    >
      <div
        class="q-pa-sm bg-responsive column"
        :style="{
          zoom: zoom,
          'font-size': kioskViewPortZoom !== 1 ? `${kioskViewPortZoom}rem` : undefined
        }"
      >
        <cart
          class="col-auto z-max scroll"
          :style="{ height: isWideLandscapeView() ? 'calc(100vh - 200px)' : 'calc(100vh - 300px)' }"
          :state="state"
          is-drawer
          hide-delivery
          hide-redemptions
          hide-voucher
          rounded-expansion
          bordered-expansion
          :display-totals="checkoutData.showTotals"
        />
        <checkout-controls
          v-if="checkoutData.showCheckoutFooter"
          class="bg-responsive column col"
          :class="[$q.platform.is.ios ? 'q-pb-lg' : '']"
          style="max-height: 160px;"
          stack-layout
          hide-amounts
          button-border-radius="8"
          button-color="secondary"
          button-padding="10px"
          :zoom="kioskViewPortZoom"
          @next="handleRouterViewNext"
        />
      </div>
    </q-drawer>
    <div
      v-if="currentRegisterClient && currentRegisterClient.registerStation && currentRegisterClient.registerStation.registerType.kioskBackgroundImageUrl"
      class="fixed-full"
    >
      <img
        class="full-size"
        :src="currentRegisterClient.registerStation.registerType.kioskBackgroundImageUrl"
        :style="'z-index: 0; object-fit: cover; width: 100%; height: 100%; position: relative; opacity: ' + registerStation.registerType.kioskOptions.background_image_opacity"
      >
    </div>
    <q-header
      v-if="state !== STATES.IDLE && state !== STATES.ACTION_SELECTION"
      ref="headerRef"
      :class="{
        'bg-transparent': $isLandscapeView(),
        'bg-responsive': !$isLandscapeView()
      }"
      :style="{ 'padding': $isLandscapeView() ? '0.5vw 0' : '0.5vh 0' }"
    >
      <div
        class="row justify-between items-center self-center"
        :style="{ 'padding': $isLandscapeView() ? '0.5vw 1vw' : '0.5vh 1vh' }"
      >
        <q-btn
          v-if="showBackButton"
          class="col-auto"
          :style="{ 'margin-left': $isLandscapeView() ? '0.5vw' : '0.5vh' }"
          :label="$t('nav.actions.goBack')"
          align="left"
          color="primary"
          :text-color="$getColor(currentSite, 'primary')"
          :size="$q.screen.gt.sm ? 'lg' : 'md'"
          :disable="loading || $router.fullPath === '/'"
          @click="backNavigation"
        />

        <img
          class="col-auto"
          :style="{ 'max-height': $isLandscapeView() ? '3.5vw' : '3.5vh' }"
          :src="logoImage"
        >
        <q-btn
          :size="$q.screen.gt.sm ? 'lg' : 'md'"
          class="col-auto"
          :style="{ 'margin-right': $isLandscapeView() ? '0.5vw' : '0.5vh' }"
          color="primary"
          :text-color="$getColor(currentSite, 'primary')"
          :label="$t('checkout.actions.startOver')"
          :disable="loading"
          @click="timeout"
        />
      </div>
      <checkout-stepper
        v-if="!isWideLandscapeView() && showCheckoutStepper"
        ref="checkoutStepper"
        class="col bg-responsive"
      />
      <q-toolbar
        v-if="!isWideLandscapeView() && checkoutData.showCartControls"
        class="text-responsive no-padding shadow-1 bg-responsive"
        style="min-height: unset"
      >
        <checkout-controls
          class="text-responsive"
          topbar
          :drawer-shown="showDrawer"
          force-large-style
          hide-amounts
          show-order-items-details
          dense
          :hide-checkout-button="!checkoutData.showCheckoutFooter"
          @toggle-drawer="toggleDrawer()"
          @next="handleRouterViewNext"
        />
      </q-toolbar>
      <q-toolbar
        v-if="!isWideLandscapeView() && showCheckoutStepper && isTicketPrintingDisabled"
        class="column justify-center text-center bg-warning"
      >
        <div
          class="q-px-md text-bold"
          :style="{ color: getTextColor(currentSite.warningColor) }"
        >
          {{ $t('kiosk.ticketPrintingDisabledWarning') }}
        </div>
      </q-toolbar>
    </q-header>
    <q-header
      v-else-if="!onLine || (!isElectronMode && (!hardwareStatusOk || !linked))"
    >
      <div class="row justify-center">
        <q-icon
          size="sm"
          name="error"
          color="negative"
        />
        {{ onLine ? $t('kiosk.errors.hardwareProblems') : $t('kiosk.errors.noInternet') }}.
      </div>
    </q-header>

    <q-page-container>
      <div
        class="fixed-full"
        :style="{ top: top }"
      >
        <q-scroll-area
          class="column full-height"
          :style="`width: 100%; max-width: ${maxWidth}; margin-left: ${marginLeft > 0 ? 'auto' : marginLeft}; margin-right: ${marginRight > 0 ? 'auto' : marginRight};`"
        >
          <checkout-stepper
            v-if="isWideLandscapeView() && showCheckoutStepper"
            ref="checkoutStepper"
            class="col"
          />
          <q-toolbar
            v-if="isWideLandscapeView() && showCheckoutStepper && isTicketPrintingDisabled"
            class="column justify-center text-center bg-warning"
          >
            <div
              class="q-px-md text-bold"
              :style="{ color: getTextColor(currentSite.warningColor) }"
            >
              {{ $t('kiosk.ticketPrintingDisabledWarning') }}
            </div>
          </q-toolbar>
          <!-- When 'next' is emitted from a checkout page, the checkout stepper determines what page to load next  -->
          <router-view
            v-slot="{ Component }"
          >
            <component
              :is="Component"
              ref="routerView"
              :key="$route.fullPath"
              :allowed-to-proceed="allowedToProceed"
              :payment-connector-payment-in-progress="paymentConnectorPaymentInProgress"
              :is-wide-landscape-view="isWideLandscapeView()"
              :request-code="requestCode"
              hide-checkout-controls
              emit-actions
              @next="handleCheckoutStepperNext"
              @back="backNavigation"
              @code-sent="(value) => requestCode = value"
              @change-state="changeState(STATES.ACTION_SELECTION)"
              @action-selected="(action, id) => changeState(action, id)"
              @movie-selected="(movieId) => movieSelected(movieId)"
              @activity-selected="(activity) => activitySelected(activity)"
              @timeout="() => state == STATES.CONFIRMATION ? timeout() : $refs.timeoutDialog.show()"
              @account-created="(userId) => logInUser(userId)"
              @request-login="() => $refs[DIALOGS.MANUAL_LOGIN].show()"
              @hardware-manager="() => $refs[DIALOGS.HARDWARE_MANAGER].show()"
              @login="() => $router.push('/find-user')"
              @register="() => $router.push('/register-user')"
              @login-success="(userId) => logInUser(userId)"
            />
          </router-view>

          <set-register-station-dialog
            v-model="showSelectRegisterStation"
            @site-changed="setThemeColors"
          />
        </q-scroll-area>
      </div>
    </q-page-container>

    <timeout-dialog
      ref="timeoutDialog"
      @timeout="timeout"
      @continue="() => resetTimer()"
    />
    <electron-scanner
      ref="electronScanner"
    />
    <hardware-manager
      v-if="currentRegisterClient && currentRegisterClient.registerStation"
      :ref="DIALOGS.HARDWARE_MANAGER"
      :hardware="hardware"
      :on-line="onLine"
      :cable-disconnected="cableDisconnected"
      :link-loading="linkLoading"
      :stripe-terminal-reconnection-attempt="stripeTerminalReconnectionAttempt"
      :stripe-terminal-reconnection-in-progress="stripeTerminalReconnectionInProgress"
      :stripe-terminal-reconnection-error="stripeTerminalReconnectionError"
      @toggle-link="toggleLink"
      @set-register-station="setRegisterStation"
    />
    <voucher-package-dialog
      :ref="DIALOGS.VOUCHER_PACKAGE"
      :order="order"
    />

    <kiosk-login
      :ref="DIALOGS.MANUAL_LOGIN"
      class="column justify-center items-center"
      :style="{
        'min-width': $isLandscapeView() ? '50vw' : '50vh',
        'padding': $isLandscapeView() ? '3vw' : '3vh'
      }"
      is-dialog
      :show-login-method-toggle="currentCircuit.kioskOptions.enable_one_time_code_login"
      :request-code="requestCode"
      @code-sent="(value) => requestCode = value"
      @login-success="(userId) => logInUser(userId)"
    />

    <action-dialog
      ref="closeActionDialog"
      :title="$t('checkout.leaveCheckoutHeading')"
      :message="$t('checkout.confirmLeaveCheckoutPrompt')"
      :ok-label="$t('checkout.actions.continueShopping')"
      :cancel-label="$t('cart.clearCart')"
      @cancel="timeout"
    />
    <action-dialog
      ref="userLoggedInDialog"
      :title="$t('auth.logInConfirmation', { name: order.user ? order.user.firstName : '' })"
      :message="$t('checkout.continueOrder')"
      :ok-label="$t('checkout.actions.continue')"
      :cancel-label="$t('checkout.actions.manageMembership')"
      @cancel="manageMembership"
      @ok="continueOrder"
    />
    <action-dialog
      ref="ticketPrintingDisabledDialog"
      :title="'This Kiosk Does Not Print Tickets'"
      :message="$t('kiosk.ticketPrintingDisabledWarning')"
      :ok-label="$t('kiosk.actions.acknowledge')"
      :cancel="false"
      persistent
      @ok="checkoutData.hasUserAcknowledgedTicketPrintingDisabled = true"
    />
  </q-layout>
</template>

<script>
/**
 * Almost all user actions alter the app state and most app states map one-to-one
 * to distinct pages, so we map actions to the page route names.
 */
export const ACTIONS = Object.freeze({
  ACTION_SELECTION: 'kiosk:action-selection',
  ALL_SHOWINGS: 'kiosk:showings',
  ALL_ACTIVITIES: 'kiosk:activities',
  SHOWING: 'kiosk:showing',
  SHOWING_SLUG: 'kiosk:showing-slug',
  ACTIVITY: 'kiosk:activity',
  ACTIVITY_DATE_TIME: 'kiosk:activity-date-time',
  ACTIVITY_ADD_ONS: 'kiosk:activity-add-ons',
  MORE_ACTIVITIES: 'kiosk:more-activities',
  COLLECT_TICKETS: 'kiosk:pickup',
  MEMBERSHIP_ACTION: 'kiosk:membership-action',
  LOGIN: 'auth:login',
  REGISTER: 'auth:register',
  CART: 'kiosk:cart',
  SEAT_CHART: 'kiosk:seat-chart',
  SEATS: 'kiosk:seats',
  ITEMS: 'kiosk:items',
  USER_ACTIONS: 'kiosk:user-actions',
  PAYMENT: 'kiosk:payment',
  CONFIRMATION: 'kiosk:confirmation',
  USER_ORDERS: 'kiosk:user-orders',
  TICKET_PACKAGE_OPTIONS: 'kiosk:ticket-package-options',
  DELIVERY_SELECTION: 'kiosk:delivery-selection'
})

/** Determines which pages need to render certain checkout components. */
export const CHECKOUT_CONTROL_REQUIRED = Object.freeze([ACTIONS.ITEMS, ACTIONS.SEATS, ACTIONS.CART, ACTIONS.DELIVERY_SELECTION, ACTIONS.SHOWING, ACTIONS.SHOWING_SLUG, ACTIONS.ACTIVITY, ACTIONS.ACTIVITY_DATE_TIME, ACTIONS.ACTIVITY_ADD_ONS, ACTIONS.MORE_ACTIVITIES, ACTIONS.TICKET_PACKAGE_OPTIONS])

export const STATES = Object.freeze({
  IDLE: 'kiosk:idle',
  ...ACTIONS
})

const DIALOGS = Object.freeze({
  HARDWARE_MANAGER: 'hardwareManager',
  VOUCHER_PACKAGE: 'issuedVoucherPackageDialog',
  MANUAL_LOGIN: 'loginDialog'
})

import { Cookies, Dark, Notify } from 'quasar'
import { useRemoveOrderItem } from 'src/composables/order/order-items/RemoveOrderItem'
import { appEnv, imgixHost, indySplashImage, isElectronMode } from 'src/config'
import Hardware from 'src/models/hardware/Hardware'
import CheckoutData from 'src/models/order/CheckoutData'
import Order from 'src/models/order/Order'
import { APPLICATION_TYPES } from 'src/models/register/RegisterType'
import { VOUCHER_TYPE_TYPES } from 'src/models/voucher/VoucherType'
import Login from 'src/modules/auth/pages/Login'
import ActivityCard from 'src/modules/checkout/components/ActivityCard'
import CheckoutControls from 'src/modules/checkout/components/CheckoutControls'
import CheckoutStepper from 'src/modules/checkout/components/CheckoutStepper'
import MovieCard from 'src/modules/checkout/components/MovieCard'
import VoucherPackageDialog from 'src/modules/checkout/components/VoucherPackageDialog'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'
import HardwareManager from 'src/modules/kiosk/components/HardwareManager'
import KioskLogin from 'src/modules/kiosk/components/KioskLogin'
import TimeoutDialog from 'src/modules/kiosk/components/TimeoutDialog'
import Cart from 'src/modules/register/components/Cart'
import ElectronScanner from 'src/modules/register/components/ElectronScanner'
import SetRegisterStationDialog from 'src/modules/register/components/SetRegisterStationDialog'

const order = new Order({}, {
  tip: true,
  orderItems: {
    itemOrderItem: {
      item: true,
      itemVariation: true,
      itemModifiers: {
        modifier: true
      }
    },
    ticket: {
      fields: 'all',
      showing: {
        movie: 'default'
      }
    },
    activityTicket: {
      user: true,
      activitySession: {
        activity: true,
        activitySpace: true,
        activitySchedule: true
      }
    },
    voucherPurchase: {
      user: true,
      voucherType: true,
      card: 'default'
    },
    issuedVoucherPackage: {
      vouchers: {
        voucherType: {
          fields: 'all',
          itemVariation: true
        }
      }
    },
    membershipInterval: 'default',
    giftCard: {
      card: 'default'
    },
    tax: true,
    discount: 'default',
    voucher: {
      voucherType: true
    },
    voucherType: true,

    order: 'default',
    canVoid: 'default',
    cannotVoidReason: 'default',
    orderItemBookingFee: true
  },
  payments: {
    giftCard: 'default'
  },
  activityBookings: {
    activity: {
      activityCategories: 'default',
      ticketTypes: 'default',
      itemPackages: 'default',
      fromPrices: true,
      maxActivitySpaceCapacity: true
    },
    activitySession: {
      activitySpace: true
    }
  },
  appliedRewards: true,
  user: {
    userMovies: true,
    userClass: true,
    seatPreferences: true,
    itemPreferences: true,
    userStripeCustomers: 'default',
    membership: {
      members: {
        userClass: true,
        membershipType: {
          membershipVouchers: {
            voucherType: true
          },
          membershipDiscounts: {
            discount: true
          }
        },
        membershipTier: true,
        vouchers: {
          voucherType: true
        }
      },
      owner: {
        fields: ['id']
      }
    },
    membershipType: {
      membershipVouchers: {
        voucherType: true
      },
      membershipDiscounts: {
        discount: true
      }
    },
    membershipTier: true,
    vouchers: {
      voucherType: true
    },
    credit: 'default',
    card: 'default',
    purchasees: {
      userClass: true,
      membershipType: {
        membershipVouchers: {
          voucherType: true
        },
        membershipDiscounts: {
          discount: true
        }
      },
      membershipTier: true,
      membership: {
        id: true,
        state: true
      },
      vouchers: {
        voucherType: true
      },
      redemptionsByShowing: true,
      redemptionsByActivitySession: true
    },
    discountRedemptions: true,
    redemptionsByShowing: true,
    redemptionsByActivitySession: true
  },
  independentVouchers: {
    voucherType: true
  },
  giftCards: 'default',
  registerStation: true,
  stripePaymentIntentClientSecret: true,
  watchQuery: false // Prevent apollo from reloading order data when a child element changes (e.g. movie is fetched) as it will clear out draft items in the order
})

export default {
  name: 'KioskLayout',
  components: {
    ActionDialog,
    SetRegisterStationDialog,
    TimeoutDialog,
    ElectronScanner,
    Cart,
    CheckoutControls,
    HardwareManager,
    VoucherPackageDialog,
    Login,
    MovieCard,
    CheckoutStepper,
    KioskLogin,
    ActivityCard
  },
  context: ['currentUser', 'currentRegisterClient'],
  configuration: ['currentCircuit', 'currentSite', 'registerStations', 'sites', 'voucherTypes', 'membershipTypes'],
  provide () {
    return {
      order: this.order,
      checkoutData: this.checkoutData
    }
  },
  setup () {
    const { removeOrderItem } = useRemoveOrderItem()
    return {
      removeOrderItem
    }
  },
  data () {
    return {
      state: null,
      checkoutData: new CheckoutData(),
      order,
      selectedMovieId: null,
      siteIntervalId: null,
      timer: 30,
      timerIntervalId: null,
      stripeTerminalReconnectionInProgress: false,
      stripeTerminalReconnectionAttempt: 0,
      stripeTerminalReconnectionWorkerNumber: 0,
      stripeTerminalReconnectionError: null,
      onLine: navigator.onLine,
      cableWatcher: null,
      cableDisconnected: false,
      linkLoading: false,
      electronPrinterWatcher: null,
      electronPrinterConnected: false,
      loading: false,
      showDrawer: this.isWideLandscapeView(),
      showDrawerLeft: this.isWideLandscapeView(),
      viewOrder: false,
      showCheckoutStepper: false,
      requestCode: false,
      environmentStatusInterval: null
    }
  },
  models: {
    hardware: {
      variables () {
        return {
          id: this.registerStation?.hardwareId
        }
      },
      immediate: true
    },
    itemVariationAvailabilitiesAndConstraintsByLocationAndRegisterStation: true,
    modifierAvailabilitiesAndConstraintsByLocationAndRegisterStation: true
  },

  computed: {
    logoImage () {
      let image = this.$q.dark.isActive ? this.currentSite.lightLogoImage : this.currentSite.darkLogoImage
      image ||= indySplashImage
      return `${imgixHost}/${image}?auto=format`
    },
    allowedToProceed () {
      if (this.receiptPrinterStatus) return true
      if (appEnv === 'development') return true
      if (appEnv === 'staging' && this.currentUser?.superUser) return true

      return false
    },
    registerStation () {
      return this.currentRegisterClient?.registerStation
    },
    showSelectRegisterStation () {
      return !this.currentUser || !this.registerStation || this.registerStation?.registerType?.applicationType !== APPLICATION_TYPES.KIOSK || this.currentUser?.userCircuitMigratedUrl
    },
    hasHardware () {
      if (this.isElectronMode) return false

      if (!this.hardware) return false

      return true
    },
    linked () {
      return this.currentRegisterClient?.id === this.hardware?.pessimisticData?.registerClientId
    },
    receiptPrinterStatus () {
      if (this.isElectronMode) return this.electronPrinterConnected

      if (this.hardware.config.hasReceiptPrinter && !this.hardware.status.receiptPrinterConnected) {
        return false
      }

      return true
    },
    hardwareStatusOk () {
      if (this.isElectronMode && this.electronPrinterConnected) {
        return true
      } else if (this.isElectronMode) {
        return false
      } else {
        return this.hardware.status.connected &&
          this.receiptPrinterStatus &&
          (!this.hardware.config.hasRfidReader || this.hardware.status.rfidReaderConnected) &&
          (!this.hardware.config.hasMagneticCardReader || this.hardware.status.magneticCardReaderConnected) &&
          (!this.hardware.config.hasQrCodeReader || this.hardware.status.qrCodeReaderConnected)
      }
    },
    paymentConnectorPaymentInProgress () {
      return _.some(this.order?.payments?.data, payment => payment.state === 'draft' && (payment.nonStripeCardPayment || payment.paymentConnectorStatusDetails?.transaction_in_progress))
    },
    kioskViewPortZoom () {
      if (this.$q.platform.is.iphone || this.$q.platform.is.ipad || this.$q.platform.is.android || this.$q.platform.is.blackberry || this.$q.platform.is.winphone || this.$q.platform.is.kindle) return 1
      return this.currentRegisterClient?.registerStation?.registerType?.kioskViewPortZoom || 1
    },
    zoom () {
      if (this.kioskViewPortZoom !== 1) {
        if (this.kioskViewPortZoom < 1.6) {
          if (this.isWideLandscapeView()) return 'calc(0.92 / ' + `${this.kioskViewPortZoom}` + ')'
          return 'calc(0.95  / ' + `${this.kioskViewPortZoom}` + ')'
        } else {
          if (this.isWideLandscapeView()) return 'calc(0.90 / ' + `${this.kioskViewPortZoom}` + ')'
          return 'calc(0.92 / ' + `${this.kioskViewPortZoom}` + ')'
        }
      }
      return undefined
    },
    top () {
      let baseHeight

      // Helper function to convert vh to px
      const vhToPx = (vh) => Math.round((vh * window.innerHeight) / 100)

      if (this.showCheckoutStepper) {
        if (this.isWideLandscapeView()) {
          baseHeight = 126
        } else {
          baseHeight = this.$q.screen.gt.sm ? 207 : 212
        }
      } else {
        if (!_.includes(ACTIONS, this.state)) {
          baseHeight = 24
        } else if (this.state === STATES.CART) {
          if (this.isWideLandscapeView()) {
            baseHeight = vhToPx(10)
          } else {
            baseHeight = vhToPx(5)
          }
        } else if (this.state === STATES.ACTION_SELECTION) {
          baseHeight = 0
        } else {
          baseHeight = 85
        }
      }

      return `${baseHeight}px`
    },
    isTicketPrintingDisabled () {
      return this.registerStation?.registerType?.kioskOptions?.disable_ticket_printing
    },
    marginLeft () {
      if (this.showDrawerLeft && this.isWideLandscapeView() && (
        (this.checkoutData.showMovieCard && !_.isNil(this.order.currentShowing)) ||
        (this.checkoutData.showActivityCard && !_.isNil(this.order.currentActivity))
      )) {
        return this.$q.screen.lt.lg ? 280 : 350
      }

      return 0
    },
    marginRight () {
      if ((this.isWideLandscapeView() || this.showDrawer) && this.checkoutData.showCartControls) {
        return this.$q.screen.lt.lg ? 280 : 350
      }

      return 0
    },
    maxWidth () {
      return `calc(100% - ${this.marginLeft + this.marginRight}px)`
    },
    showBackButton () {
      return this.state !== STATES.IDLE
    }
  },
  watch: {
    state: {
      handler: function () {
        if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
          this.$rollbar.info(`Kiosk state changed to ${this.state}`, {
            orderId: this.order.id,
            orderUserId: this.order.user?.id,
            userId: this.currentUser?.id
          })
        }

        if (!this.isTicketPrintingDisabled) return

        if (this.checkoutData.hasUserAcknowledgedTicketPrintingDisabled) return

        if (_.includes(CHECKOUT_CONTROL_REQUIRED, this.state)) {
          this.$refs.ticketPrintingDisabledDialog.show()
        }
      },
      immediate: true
    },
    $route: {
      immediate: true,
      handler: async function (to, from) {
        if (to.path === '/') {
          this.state = STATES.IDLE
        } else {
          this.state = to.name
        }

        if (this.state === STATES.IDLE) {
          if (this.order.isRemote || this.order.user?.isRemote) {
            this.$refs.timeoutDialog.show()
          } else {
            this.resetTimer()
          }
        }

        if (_.includes(CHECKOUT_CONTROL_REQUIRED, this.state) || this.state === STATES.PAYMENT) {
          this.showCheckoutStepper = true
          this.checkoutData.hasRedemptions = _.some(this.voucherTypes?.data, voucherType => voucherType.isReward)
        } else {
          this.checkoutData.showCartControls = false
          this.checkoutData.showMovieCard = false
          this.checkoutData.showActivityCard = false
          this.showCheckoutStepper = false
        }
        if (!Cookies.has('register_client_id') && this.currentRegisterClient?.isRemote) {
          // Register client has been deleted, need to resave
          await this.currentRegisterClient.save()
          if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
            this.$rollbar.info('Kiosk register client saved')
          }
        }
        this.showDrawer = this.$isLandscapeView()
      }
    },
    'hardware.id': {
      handler: function () {
        this.subscribeToHardwareChanges()
      },
      immediate: true
    },
    'currentRegisterClient.registerStation.registerType.kioskViewPortZoom': {
      handler () {
        if (!this.currentRegisterClient?.registerStation?.registerType) {
          return
        }
        const viewPortZoom = this.currentRegisterClient.registerStation.registerType.kioskViewPortZoom || 1
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          let viewport = document.querySelector('meta[name=viewport]')
          if (!viewport) {
          // in case there is no view port meta tag creates one and add it to the head
            viewport = document.createElement('meta')
            viewport.name = 'viewport'
            document.getElementsByTagName('head')[0].appendChild(viewport)
          }
          const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

          const content = `width=${width / viewPortZoom}, initial-scale=${viewPortZoom}, maximum-scale=${viewPortZoom}, user-scalable=no`
          viewport.setAttribute('content', content)
        } else {
          document.body.style.zoom = viewPortZoom
        }
      },
      immediate: true
    },
    'currentRegisterClient.registerStation.registerType.transformedStyles': {
      handler () {
        if (!this.currentRegisterClient?.registerStation?.registerType) {
          return
        }
        this.$mh.setCustomPageStyles(this.currentRegisterClient.registerStation.registerType.transformedStyles)
      },
      immediate: true
    },
    'currentSite.activeInventoryStrategy.inventoryRestrictionType': {
      handler: function () {
        if (this.currentSite?.activeInventoryStrategy?.inventoryRestrictionType) {
          this.$salesRestrictions.fetchItemVariationAvailabilitiesAndConstraints = () => {
            this.updateItemVariationAvailabilitiesAndConstraints()
          }

          this.updateItemVariationAvailabilitiesAndConstraints()

          this.$salesRestrictions.fetchModifierAvailabilitiesAndConstraints = () => {
            this.updateModifierAvailabilitiesAndConstraints()
          }

          this.updateModifierAvailabilitiesAndConstraints()
        } else {
          if (this.$salesRestrictions.fetchItemVariationAvailabilitiesAndConstraints) {
            this.$salesRestrictions.fetchItemVariationAvailabilitiesAndConstraints = null
          }

          if (this.$salesRestrictions.fetchModifierAvailabilitiesAndConstraints) {
            this.$salesRestrictions.fetchModifierAvailabilitiesAndConstraints = null
          }
        }
      },
      immediate: true
    },
    'currentUser.id': {
      handler () {
        if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
          this.$rollbar.info('Kiosk current user id changed', { userId: this.currentUser?.id, orderId: this.order?.id })
        }
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, { STATES, isElectronMode, DIALOGS })
    this.setThemeColors()
  },
  async mounted () {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    window.addEventListener('click', this.resetTimer)
    window.addEventListener('mousemove', this.resetTimer)
    window.addEventListener('touchstart', this.resetTimer)
    window.addEventListener('touchend', this.resetTimer)
    window.addEventListener('touchcancel', this.resetTimer)
    window.addEventListener('touchmove', this.resetTimer)

    this.$cardHandler.userCardHandler = this.handleUserCardSwipe
    this.$cardHandler.voucherHandler = this.handleVoucherScan
    this.$cardHandler.voucherPackageHandler = this.handleVoucherPackageScan
    this.$cardHandler.giftCardHandler = this.handleGiftCardScan
    this.$cardHandler.orderHandler = this.handleOrderScan

    if (this.isElectronMode) {
      this.electronPrinterWatcher = setInterval(() => {
        this.fetchElectronPrinterStatus()
      }, 1000)
    }

    this.cableWatcher = setInterval(() => {
      this.cableDisconnected = this.$cable.connection.disconnected
    }, 1000)

    this.$remoteCommands.handleRequestConsoleStream = () => {
      if (!this.currentRegisterClient) return
      this.$setupConsoleStream(this.currentRegisterClient.id)
    }

    this.$remoteCommands.handleRequestScreenData = () => {
      if (!this.currentRegisterClient) return
      this.$startShareScreen(this.currentRegisterClient.id)
    }

    this.siteIntervalId = setInterval(() => {
      this.currentSite.fetch(true)
    }, 10 * 60 * 1000)

    this.timerIntervalId = setInterval(() => {
      const isIdleWithOrderOrUserData = this.state === STATES.IDLE && (this.order.user?.isRemote || this.order.isRemote)
      if ((this.state !== STATES.IDLE || isIdleWithOrderOrUserData) && this.state !== STATES.PAYMENT && this.state !== STATES.CONFIRMATION) {
        if (this.timer === 0) {
          this.$refs.timeoutDialog.show()
        }
        this.timer = this.timer - 1
      }
    }, 1000)

    // Update current app version and electron version.
    this.environmentStatusInterval = setInterval(() => {
      if (!this.currentRegisterClient) return

      this.currentRegisterClient.updateEnvironmentStatus(window.electronVersion || null,
        { jsHeapSizeLimit: window.performance?.memory?.jsHeapSizeLimit, totalJSHeapSize: window.performance?.memory?.totalJSHeapSize, usedJSHeapSize: window.performance?.memory?.usedJSHeapSize, totalLayoutCreations: this.$vueLayoutCountTracker.totalCreations, currentLayoutInstanceCount: this.$vueLayoutCountTracker.getInstanceCount() })
    }, 5 * 60 * 1000)

    if (this.currentRegisterClient) {
      // Send data with zero values so we can detect when app in launched
      this.currentRegisterClient.updateEnvironmentStatus(window.electronVersion || null,
        { jsHeapSizeLimit: 0, totalJSHeapSize: 0, usedJSHeapSize: 0 })
    }

    if (!this.state) {
      this.state = STATES.IDLE
      this.$router.push('/')
    }

    this.showDrawer = this.$q.screen.width > 1250

    this.configureStripe()
  },
  beforeUnmount () {
    clearInterval(this.siteIntervalId)
    clearInterval(this.timerIntervalId)

    if (this.cableWatcher) {
      clearInterval(this.cableWatcher)
    }
    if (this.electronPrinterWatcher) {
      clearInterval(this.electronPrinterWatcher)
    }

    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
    window.removeEventListener('click', this.resetTimer)
    window.removeEventListener('mousemove', this.resetTimer)
    window.removeEventListener('touchstart', this.resetTimer)
    window.removeEventListener('touchend', this.resetTimer)
    window.removeEventListener('touchcancel', this.resetTimer)
    window.removeEventListener('touchmove', this.resetTimer)

    if (this.$salesRestrictions?.fetchItemVariationAvailabilitiesAndConstraints) {
      this.$salesRestrictions.fetchItemVariationAvailabilitiesAndConstraints = null
    }

    if (this.$salesRestrictions.fetchModifierAvailabilitiesAndConstraints) {
      this.$salesRestrictions.fetchModifierAvailabilitiesAndConstraints = null
    }

    if (this.environmentStatusInterval) {
      clearInterval(this.environmentStatusInterval)
    }
  },
  methods: {
    handleRouterViewNext () {
      this.$refs.routerView?.next?.()
    },
    handleCheckoutStepperNext () {
      this.$refs.checkoutStepper?.next?.()
    },
    toggleDrawer () {
      this.showDrawer = !this.showDrawer
    },
    setThemeColors () {
      if (!this.currentSite) return
      this.$mh.setThemeColors(this.currentSite)
      // For Dark Mode toggle
      Dark.set(this.currentSite.consumerConfig.darkMode)
    },
    async setRegisterStation () {
      this.$refs[DIALOGS.HARDWARE_MANAGER].hide()
      this.$unsubscribeFromCableSubscriptions()
      await this.currentRegisterClient.delete()
      await this.$handleAuthChange()
    },
    resetTimer () {
      this.timer = 30
    },
    changeState (newState, id = null) {
      if (!id) {
        this.$router.push({ name: newState })
      } else {
        const idParam = newState === STATES.SEATS ? 'showing' : 'id'
        this.$router.push({ name: newState, params: { [idParam]: id } })
      }
    },
    async handleOrderScan (orderId) {
      this.resetTimer()

      if (this.$refs.routerView?.handleOrderScan) {
        this.$refs.routerView.handleOrderScan(orderId)
        return
      }

      this.order.id = orderId
      await this.order.fetch(true)
      this.changeState(STATES.COLLECT_TICKETS)
    },
    fetchElectronPrinterStatus () {
      const printerStatus = window.electronPrinter.status()

      if (!printerStatus.error) {
        this.electronPrinterConnected = true
      } else this.electronPrinterConnected = false
    },
    handleVoucherScan (voucher, valid, message) {
      this.resetTimer()
      if (voucher) {
        if (valid) {
          if (voucher.voucherType.type === 'specific-membership') {
            this.applySpecificMembershipVoucher(voucher)
          } else {
            Notify.create({
              timeout: 5000,
              message: (valid ? `${message}, applied to order` : message),
              position: 'top',
              color: (valid ? 'primary' : 'negative')
            })
            this.order.addIndependentVoucher(voucher)
          }
        }
      } else {
        Notify.create({
          timeout: 5000,
          message,
          position: 'top',
          color: 'primary'
        })
      }
    },
    handleVoucherPackageScan (voucherPackage) {
      this.resetTimer()
      this.$refs[DIALOGS.VOUCHER_PACKAGE].show(voucherPackage)
    },
    async handleUserCardSwipe (card) {
      this.resetTimer()
      const user = card.user

      if (user.isDayPassUser && !user.dayPassDate) {
        Notify.create({
          message: this.$i18n.t('ticket.errors.dayPassNoLongerValid'),
          type: 'negative',
          position: 'top'
        })
      } else {
        this.logInUser(user.id)
      }
    },
    async handleGiftCardScan (giftCard) {
      this.resetTimer()
      const actions = []

      if (giftCard.balance === 0) {
        Notify.create({
          timeout: 2000,
          message: this.$i18n.t('giftCard.errors.empty'),
          position: 'top',
          color: 'negative',
          actions
        })
        return
      }

      Notify.create({
        timeout: 2000,
        message: this.$i18n.t('giftCard.addedAsPaymentMethod'),
        caption: `${this.$i18n.n(giftCard.balance, 'currency')}`,
        position: 'top',
        color: 'accent',
        actions
      })

      this.order.addGiftCard(giftCard)
    },
    movieSelected (movieId) {
      this.selectedMovieId = movieId
      this.$router.push(this.currentSite.path(`/movie/${movieId}`))
    },
    updateOnlineStatus (event) {
      const { type } = event
      this.onLine = type === 'online'
    },
    async logInUser (userId) {
      this.$refs[DIALOGS.MANUAL_LOGIN].hide()

      if (userId === this.order.user?.id) {
        // User is already logged in and matches the current user, so we can skip
        return
      }

      const orderUser = this.order.setRelated('user', { id: userId })
      if (orderUser.options.structure) {
        // options.structure should always be present at this point, but just in case.
        // Structure determines what fields are included in GQL query. It's not meant
        // to be modified after being set, but this is a hack to force this field to be
        // requested in the User query, so we know the person's permissions.
        orderUser.options.structure.permittedFrontendActions = true
      }
      await orderUser.fetch(true)

      if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
        this.$rollbar.info('Kiosk order user changed', { orderId: this.order.id, orderUserId: this.order.user?.id, userId: this.currentUser?.id })
      }

      if (this.state === STATES.USER_ORDERS || this.state === STATES.USER_ACTIONS) {
        // Do nothing, we are already on the correct page
      } else if (this.state === STATES.COLLECT_TICKETS) {
        // We can infer the user wants to collect tickets, so we should go to the user orders page
        this.$router.push('user-orders')
      } else if (this.state === STATES.IDLE) {
        // We can go to the management page directly, as we are not in the middle of a transaction
        this.manageMembership()
      } else {
        // User may be in the middle of a transaction, so we need to show a dialog to confirm what the user wants to do
        this.$refs.userLoggedInDialog.show()
      }
    },
    manageMembership () {
      this.$router.push('/user-actions')
    },
    continueOrder () {
      this.$router.push('/action-selection')
    },
    applySpecificMembershipVoucher (voucher) {
      if (voucher.voucherType.type !== VOUCHER_TYPE_TYPES.SPECIFIC_MEMBERSHIP) return

      if (this.order.orderItems.data.length !== 0 && !this.order.purchasingMembership) {
        Notify.create({
          timeout: 5000,
          message: 'Membership vouchers can only be used with membership orders',
          position: 'top',
          color: 'negative',
          actions: [{ label: 'View Voucher History', size: 'sm', textColor: 'white', handler: () => { this.$refs.orderFilterDialog.show(null, voucher.id, null, null) } }]
        })
      } else if (!this.order.user) {
        Notify.create({
          timeout: 5000,
          message: 'Sign up or log in to use a membership voucher',
          position: 'top',
          color: 'negative',
          actions: [{ label: 'View Voucher History', size: 'sm', textColor: 'white', handler: () => { this.$refs.orderFilterDialog.show(null, voucher.id, null, null) } }]
        })
        this.$router.push('/membership-action')
      } else {
        Notify.create({
          timeout: 5000,
          message: `${voucher.voucherType.name}, applied to order`,
          position: 'top',
          color: 'primary',
          actions: [{ label: 'View Voucher History', size: 'sm', textColor: 'white', handler: () => { this.$refs.orderFilterDialog.show(null, voucher.id, null, null) } }]
        })
        this.order.addIndependentVoucher(voucher)
        this.$router.push('/user-actions')
        this.$nextTick(() => {
          this.$refs.routerView.showModifyMembershipDialog = true
          this.$nextTick(() => {
            this.$refs.routerView.$refs.modifyMembershipForm.applySpecificMembershipVoucher()
          })
        })
      }
    },
    async configureStripe () {
      if (!this.currentRegisterClient?.registerStation?.useStripeTerminalPayments) return

      this.$payments.status.reconnecting = true
      this.$payments.disconnectHandler = this.terminalDisconnectHandler
      await this.$payments.configureStripe(this.currentSite.standardConnectAccountId)

      const result = await this.$payments.terminalConnectionInitalizer(this.currentRegisterClient, this.currentRegisterClient?.stripeTerminalLocationId, false, true, false)
      if (result.error) {
        this.$payments.handleTerminalDisconnect()
      } else {
        this.$payments.reconnecting = false
      }
    },
    async terminalDisconnectHandler () {
      if (this.stripeTerminalReconnectionInProgress) return false

      const retryDelay = 5000
      let connectionSuccessful = false
      const workerNumber = ++this.stripeTerminalReconnectionWorkerNumber

      this.stripeTerminalReconnectionInProgress = true
      this.stripeTerminalReconnectionAttempt = 0

      while (this.stripeTerminalReconnectionWorkerNumber === workerNumber && this.stripeTerminalReconnectionInProgress && !connectionSuccessful) {
        const terminalInitalizerResult = await this.$payments.terminalConnectionInitalizer(this.currentRegisterClient, this.currentRegisterClient?.stripeTerminalLocationId, true, false)

        if (terminalInitalizerResult.error) {
          this.stripeTerminalReconnectionError = terminalInitalizerResult.error
        }

        if (terminalInitalizerResult.error && terminalInitalizerResult.recoverable) {
          await new Promise(resolve => {
            this.stripeTerminalReconnectionTimeout = setTimeout(resolve, retryDelay)
          })
        } else if (terminalInitalizerResult.error) {
          this.stripeTerminalReconnectionInProgress = false
        } else {
          connectionSuccessful = true
        }

        if (this.stripeTerminalReconnectionWorkerNumber === workerNumber) {
          ++this.stripeTerminalReconnectionAttempt
        }
      }

      if (this.stripeTerminalReconnectionWorkerNumber !== workerNumber) return

      this.stripeTerminalReconnectionInProgress = false
      this.stripeTerminalReconnectionAttempt = 0
    },
    async connectToStripeTerminal () {
      if (!this.selectedStripeTerminal || !this.currentRegisterClient) return

      this.connectingToChipReader = true

      const result = await this.$payments.terminalConnectionInitalizer(this.currentRegisterClient, this.currentRegisterClient?.stripeTerminalLocationId, false, true, this.selectedStripeTerminal)

      if (!result.error) {
        this.currentRegisterClient.stripeTerminalSerialNumber = this.selectedStripeTerminal.serial_number
        await this.currentRegisterClient.save()
        Notify.create({
          message: 'Chip Reader Connected',
          type: 'positive',
          position: 'bottom-left',
          classes: 'hardware-notify'
        })
        this.showSelectTerminal = false
      } else {
        Notify.create({
          message: result.error,
          type: 'negative',
          position: 'bottom-left',
          classes: 'hardware-notify'
        })
      }

      this.connectingToChipReader = false
    },
    async toggleLink () {
      if (!this.hardware || !this.currentRegisterClient || isElectronMode) return

      if (this.currentRegisterClient.id === this.hardware.registerClientId) return

      this.linkLoading = true

      this.hardware.registerClientId = this.currentRegisterClient.id

      const saveHardware = new Hardware({ id: this.hardware.id, registerClientId: this.hardware.registerClientId }, { fields: ['id', 'registerClientId'] })

      await saveHardware.save()

      this.linkLoading = false
    },
    subscribeToHardwareChanges () {
      if (isElectronMode) return

      if (!this.hardware) return

      this.$hardware.hardwareUpdated = (updatedHardware) => {
        const previousLinked = this.linked
        this.hardware.setData(updatedHardware, true)

        if (!this.linked && previousLinked) {
          Notify.create({
            message: 'You are no longer linked to the hardware. Someone else has connected.',
            type: 'warning',
            position: 'bottom-left',
            classes: 'hardware-notify'
          })
        }
      }

      this.$hardware.subscribeToHardwareChanges(this.hardware)
    },
    async backNavigation () {
      if ((this.state === STATES.MEMBERSHIP_ACTION || this.state === STATES.SEATS || this.state === STATES.SHOWING) && this.requestCode === true) {
        this.requestCode = false
        return
      }
      if (this.$paymentConnectorHandler && this.$paymentConnectorHandler.requestCancel) {
        this.loading = true
        const result = await this.$paymentConnectorHandler.requestCancel()
        if (!result) {
          this.loading = false
          return
        }
      }

      if (this.$router.fullPath === '/') {
        this.loading = false
        return
      }

      this.$router.back()

      if (this.$router.fullPath === '/') {
        this.order.reset()
      }

      this.loading = false
    },
    async timeout () {
      if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
        this.$rollbar.info('Kiosk timeout')
      }

      if (this.$paymentConnectorHandler && this.$paymentConnectorHandler.requestCancel) {
        this.loading = true
        const result = await this.$paymentConnectorHandler.requestCancel()
        if (!result) {
          this.loading = false
          return
        }
      }

      await Promise.all([
        this.order.reset(),
        this.checkoutData.reset()
      ])

      this.$router.replace('/').catch(() => {})
      this.loading = false

      _.each(Object.values(DIALOGS), dialog => this.$refs[dialog]?.hide && this.$refs[dialog].hide())

      // Clear 'don't show the alcohol acknowledgement' cookie after the session completed or reset
      if (Cookies.has(this.$constants.cookies.alcoholAcknowledgement)) {
        Cookies.remove(this.$constants.cookies.alcoholAcknowledgement)
      }
      // Clear 'don't show pinch to zoom animation' cookie after the session completed or reset
      if (Cookies.has(this.$constants.cookies.seatChartCookies)) {
        Cookies.remove(this.$constants.cookies.seatChartCookies)
      }
    },
    async collectUserOrder (order) {
      this.order.id = order.id
      await this.order.fetch(true)
      this.changeState(STATES.COLLECT_TICKETS)
    },
    selectMovie (movieUrlSlugOrId) {
      if (this.$order.orderItems.data.length > 0) {
        this.$refs.closeActionDialog.show()
      } else {
        this.$router.push(this.currentSite.path(`/movie/${movieUrlSlugOrId}`))
      }
    },
    removeTicketsWithUnselectedSeats () {
      _.each(_.filter(this.order.orderItems.data, orderItem => {
        return orderItem.type === 'ticket' &&
          orderItem.state === 'draft' &&
          orderItem.ticket.showing.reservedSeating &&
          !orderItem.ticket.seatName
      }), orderItem => {
        this.removeOrderItem(orderItem)
      })
    },
    isWideLandscapeView () {
      return this.$isLandscapeView() && (this.$q.screen.width > 1250)
    },
    async updateItemVariationAvailabilitiesAndConstraints () {
      await this.itemVariationAvailabilitiesAndConstraintsByLocationAndRegisterStation.fetch(true)
      this.$setItemVariationAvailabilitiesAndConstraints?.(this.itemVariationAvailabilitiesAndConstraintsByLocationAndRegisterStation.value)
    },
    async updateModifierAvailabilitiesAndConstraints () {
      await this.modifierAvailabilitiesAndConstraintsByLocationAndRegisterStation.fetch(true)
      this.$setModifierAvailabilitiesAndConstraints?.(this.modifierAvailabilitiesAndConstraintsByLocationAndRegisterStation.value)
    },
    getTextColor (color) {
      return this.$isColorDark(color) ? 'white' : 'black'
    },
    activitySelected (activity) {
      this.$router.push({ name: ACTIONS.ACTIVITY, params: { slug: activity.urlSlug } })
    },
    async createAnotherBooking () {
      this.loading = true

      try {
        const newActivityBooking = await this.order.createNewActivityBooking()

        this.$router.push({
          name: ACTIONS.ACTIVITY,
          params: { slug: this.order.currentActivity.urlSlug },
          query: { activityBookingId: newActivityBooking.id }
        })
      } catch (error) {
        this.$rollbar.error('Failed to create new activity booking', error)

        this.$q.notify({
          message: this.$t('pages.activityTicketsPage.messages.errorCreatingActivityBooking'),
          color: 'negative',
          position: 'top'
        })
      } finally {
        this.loading = false
      }
    }
  }
}

</script>

<style lang="scss">
.kiosk-layout {
  background-color: "#26a69"
}

.media-player {
  background-color: black;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.portrait .q-drawer {
  position: fixed;
}
.kiosk-layout .bg-transparent > .q-drawer {
  background: transparent;
}
.kiosk-layout .container {
  max-width: 100%;
}
.kiosk-layout .q-drawer.q-drawer--left{
  background: transparent;
}
/** Ticket Container Styles **/
.kiosk-layout .ticketContainer{
   position: relative;
   overflow: hidden;
   width: 100%;
   height: 100%;
}
.kiosk-layout .ticketContainerHorShadow{
  background: radial-gradient(circle, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 40%);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0.1vh 0.3vh 0px,
  rgba(0, 0, 0, 0.06) 0px 0.1vh 0.2vh 0px,
  0 0 50vw rgba(0, 0, 0, 0.05) inset;
}
.kiosk-layout .ticketContainerVerShadow{
  background: radial-gradient(circle, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 80%);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0.1vh 0.3vh 0px,
  rgba(0, 0, 0, 0.06) 0px 0.1vh 0.2vh 0px,
  0 0 50vw rgba(0, 0, 0, 0.05) inset;
}
.kiosk-layout .ticketContainer:after{
  content: "";
  display: block;
  position: absolute;
  background-color: red;
  border: 1px solid rgba(220, 220, 220,0.5);
}

.kiosk-layout .ticket{
  border: 1px solid rgba(220, 220, 220,0.5);
}
.kiosk-layout .ticketDivider:before{
  content: "";
  display: block;
  position: absolute;
  background-color: var(--q-background);
  border: 1px solid rgba(220, 220, 220,0.5);
}
.kiosk-layout .ticketDivider.full-width:before {
  width: 5vw;
  height: 5vw;
  border-radius: 2.5vw;
  left: -2.5vw;
}
.kiosk-layout .ticketDivider.full-height:before {
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  top: -2.5vh;
}
.kiosk-layout .ticketDivider:after{
  content: "";
  display: block;
  position: absolute;
  background-color: var(--q-background);
  border: 1px solid rgba(220, 220, 220,0.5);
}

.kiosk-layout .ticketDivider.full-width:after {
  width: 5vw;
  height: 5vw;
  border-radius: 2.5vw;
  right: -2.5vw;
}
.kiosk-layout .ticketDivider.full-height:after {
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  bottom: -2.5vh;
}
.kiosk-layout .ticketDivider.full-width .DividerLine {
  height: 0;
  border-bottom: 1.8vh dotted transparent;
}
.kiosk-layout .ticketDivider.full-height .DividerLine {
  width: 0;
  border-right: 1.8vh dotted transparent;
}

.body--dark .kiosk-layout .bg-responsive {
  background-color: rbga(0, 0, 0, 0.1)
}

</style>
